// Central data + SEO metadata for every product & session page
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_ask-answers-18/artifacts/8cv4k791_IMG_5143.png";
export const LOGO_DARK_URL = "https://customer-assets.emergentagent.com/job_ask-answers-18/artifacts/op23a863_IMG_4872.png";
export const HERO_PHOTO_POSITION = "center";
export const DAWN_PORTRAIT = "https://static.wixstatic.com/media/75e279_eb3e7628e4b143cfba889b72b3dbde7b~mv2.jpeg/v1/fill/w_722,h_1125,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_1047.jpeg";
export const DECK_IMG = "https://customer-assets.emergentagent.com/job_ask-answers-18/artifacts/4ajbb6dx_33619a43-a552-4e55-b7b4-a9e96672a917.jpeg";

export const PRODUCTS = [
  {
    id: "dream-connection",
    slug: "dream-connection",
    name: "Dream Connection Snapshot",
    shortName: "Dream Connection",
    price: 19.95,
    tag: "Starter Snapshot",
    jewel: "topaz",
    theme: "#2E7FDB",
    tagline: "Where your intuition is guiding you next.",
    desc: "A guided six-senses reflection to reveal what your inner knowing has been whispering. Selfie prompts, journaling questions, and pattern anchors.",
    seo: {
      title: "Dream Connection Snapshot — Follow Your Intuition | SnapshotFame",
      description: "A guided dream & intuition self-reflection experience. Discover what your inner knowing has been trying to tell you. Digital download for $19.95.",
      keywords: "dream interpretation, intuition guide, self-reflection PDF, inner voice, dream meaning, spiritual journal, snapshot fame",
      h1: "Dream Connection Snapshot",
      subheading: "Follow the whisper of your intuition.",
    },
    longDesc: [
      "You already know something. The Dream Connection Snapshot is designed for the moments when your intuition has been whispering — but you haven't quite been able to hear it.",
      "Through a series of six-senses prompts (visual, auditory, kinesthetic, olfactory, taste, and intuitive), you'll take selfies while holding each thought — and journal what surfaces.",
      "This isn't dream analysis. It's a mirror. You'll see the pattern your intuition has been drawing for you.",
    ],
    includes: [
      "Guided Dream Petal reflection prompts",
      "Six-senses selfie journey",
      "Downloadable digital PDF",
      "Yours to return to, any time",
    ],
  },
  {
    id: "love-connection",
    slug: "love-connection",
    name: "Love Connection Snapshot",
    shortName: "Love Connection",
    price: 29.95,
    tag: "Heart Snapshot",
    jewel: "rose",
    theme: "#D244A6",
    tagline: "How you open, bond, and protect your heart.",
    desc: "A private mirror for how you love — and what keeps repeating. Uncover the story your relationships are trying to tell you.",
    seo: {
      title: "Love Connection Snapshot — Relationship Pattern Self-Reflection | SnapshotFame",
      description: "See the patterns in your relationships, dating, and self-love. A guided digital self-reflection PDF for anyone repeating the same story in love. $29.95.",
      keywords: "relationship patterns, dating insights, self-love, love reflection, attachment patterns, relationship coach alternative, heart healing, love language, why do I keep dating",
      h1: "Love Connection Snapshot",
      subheading: "The story your relationships have been trying to tell you.",
    },
    longDesc: [
      "If you keep meeting the same person in different faces — you're not broken. You're repeating a pattern.",
      "The Love Connection Snapshot is a private mirror for how you open, bond, and protect your heart. Through the Six-Senses Mirror, you'll see the invisible thread running through your relationships.",
      "This isn't dating advice. This isn't diagnosis. It's the reflection that lets you finally see it — clearly.",
    ],
    includes: [
      "Heart Petal guided reflection",
      "Attachment & bonding pattern prompts",
      "Downloadable digital PDF",
      "Selfie-based mirror journey",
    ],
  },
  {
    id: "financial-freedom",
    slug: "financial-freedom",
    name: "Financial Freedom Snapshot",
    shortName: "Financial Freedom",
    price: 29.95,
    tag: "Money Snapshot",
    jewel: "emerald",
    theme: "#2AA84A",
    tagline: "Your relationship with worth, money, and receiving.",
    desc: "The financial patterns you've been repeating — brought into the light. Three petals: Abundance, Growth, Prosperity.",
    seo: {
      title: "Financial Freedom Snapshot — Money Mindset & Abundance | SnapshotFame",
      description: "Uncover the money patterns you've been repeating. A guided self-reflection PDF on abundance, worth, and financial freedom. Digital download, $29.95.",
      keywords: "money mindset, abundance mindset, financial patterns, money block, wealth psychology, receiving money, financial freedom, prosperity mindset, snapshotfame",
      h1: "Financial Freedom Snapshot",
      subheading: "Your money is trying to tell you something.",
    },
    longDesc: [
      "Your bank account is a mirror. So are your money habits. So is the belief you inherited before you were old enough to question it.",
      "The Financial Freedom Snapshot walks you through three petals — Abundance, Growth, and Prosperity — using the Six-Senses Mirror to surface the pattern quietly running your finances.",
      "This isn't a budgeting worksheet. It's a reflection of what's actually driving your relationship with worth, money, and receiving.",
    ],
    includes: [
      "Three financial petals: Gold, Emerald, Purple",
      "Six-senses money-pattern prompts",
      "Downloadable digital PDF",
      "Selfie-based mirror journey",
    ],
  },
  {
    id: "six-color-complete",
    slug: "six-color-complete",
    name: "6-Color Complete Snapshot",
    shortName: "6-Color Complete",
    price: 95,
    tag: "The Full Mirror",
    jewel: "gold",
    theme: "#F5D48A",
    tagline: "The complete Six-Senses Mirror experience.",
    desc: "All six petals. Every color. The full guided journey through your patterns of love, money, dreams, direction, creativity, and identity.",
    seo: {
      title: "6-Color Complete Snapshot — The Full Six-Senses Mirror | SnapshotFame",
      description: "The complete self-reflection experience. All six petals — love, money, dreams, direction, creativity, and identity. Digital download, $95.",
      keywords: "complete self reflection, six senses mirror, full psychic reading digital, life pattern audit, personal growth workbook, spiritual snapshot",
      h1: "The 6-Color Complete Snapshot",
      subheading: "Every mirror. Every pattern. The whole picture.",
    },
    longDesc: [
      "This is the full mirror. All six petals of the Six-Senses Mirror System — Love, Abundance, Dream & Direction, Creative Identity, and everything in between.",
      "For the person who doesn't just want a glimpse — they want the whole reflection.",
      "You'll move through the complete guided journey at your own pace, uncovering the interconnected patterns shaping every corner of your life.",
    ],
    includes: [
      "All six colored petals",
      "Every Six-Senses reflection prompt",
      "The complete downloadable PDF",
      "The deepest mirror we offer",
    ],
  },
];

export const DECK = {
  id: "mirror-lotus-deck",
  slug: "mirror-lotus",
  name: "Mirror Lotus 21-Card Digital Deck",
  shortName: "Mirror Lotus",
  price: 75,
  jewel: "gold",
  theme: "#F5D48A",
  seo: {
    title: "Mirror Lotus 21-Card Digital Deck — Symbolic Reflection Cards | SnapshotFame",
    description: "A 21-card symbolic self-discovery deck by Dawn Delisle. Digital reflection cards that pair with any Snapshot experience. $75 digital download.",
    keywords: "symbolic reflection cards, self-discovery deck, digital tarot alternative, oracle cards, mirror lotus, pattern cards, spiritual card deck, dawn delisle deck",
    h1: "The Mirror Lotus Deck",
    subheading: "A 21-card custom digital deck for the seeker.",
  },
  longDesc: [
    "The Mirror Lotus System is a hand-crafted collection of 21 symbolic cards designed to reveal the hidden patterns behind what you see.",
    "Unlike traditional tarot, Mirror Lotus doesn't predict — it reflects. Each card is a doorway into a specific pattern of thought, behavior, or feeling.",
    "Every deck includes the complete Mirror Lotus Guidebook — a companion PDF with every card's meaning, reflection prompt, and shadow work.",
  ],
  includes: [
    "21 symbolic Mirror Lotus cards",
    "The complete Mirror Lotus Guidebook (PDF)",
    "Delivered personally by Dawn",
    "Pairs with any Snapshot experience",
    "Yours to keep, forever",
  ],
};

export const SESSIONS = [
  {
    id: "session-30",
    slug: "clarity-session",
    name: "Let's Talk Now",
    shortName: "Let's Talk Now",
    duration: "You choose · 5 min minimum",
    price: null,
    perMinute: true,
    priceLabel: "$1 / min",
    ctaLabel: "Request a Time",
    jewel: "topaz",
    theme: "#2E7FDB",
    desc: "A friendly conversation with Dawn. Pay only for the minutes you want.",
    seo: {
      title: "Let's Talk Now with Dawn Delisle — $1 per Minute | SnapshotFame",
      description: "A friendly conversation with Dawn Delisle, Life Clarity Chic. $1 per minute, prepaid via PayPal. You choose the length, Dawn personally arranges the time.",
      keywords: "clarity session, pay per minute coaching, talk to dawn delisle, affordable life clarity, intuitive conversation, pattern recognition call",
      h1: "Let's Talk Now",
      subheading: "",
    },
    longDesc: [
      "This is me, Dawn — like a friend who happens to see straight through to the truth.",
      "You decide how many minutes you want. 5 minutes, 20 minutes, an hour — whatever fits. $1 a minute, prepaid through PayPal.",
      "No scripts. No coaching curriculum. Just my 40+ years of pattern recognition applied directly to what you brought.",
    ],
    includes: [
      "You choose the length (5 min minimum)",
      "$1 per minute · prepaid via PayPal",
      "Not satisfied? Full refund.",
    ],
  },
  {
    id: "session-60",
    slug: "truth-session",
    name: "60-Minute Truth Session",
    shortName: "The Truth Session",
    duration: "60 minutes",
    price: 150,
    jewel: "gold",
    theme: "#F5D48A",
    desc: "A private hour with Dawn. Go deep. See what's actually driving your results — clearly.",
    seo: {
      title: "60-Minute Truth Session — Deep Life Clarity Reading | SnapshotFame",
      description: "A full private hour with Dawn Delisle. Pattern recognition applied to your life, relationships, money, or direction. See what's actually driving your results. $150 USD.",
      keywords: "truth session, private psychic reading, life clarity session, one on one life reading, 60 minute intuitive session, deep pattern reading, dawn delisle truth session",
      h1: "The Truth Session",
      subheading: "A private hour. The whole pattern.",
    },
    longDesc: [
      "You're not stuck. You're repeating patterns. In 60 minutes, Dawn shows you what's actually driving your results — clearly.",
      "This is Dawn's signature private session. A full hour of pattern recognition applied to whatever you bring: relationships, money, direction, purpose, or the question you've been carrying quietly.",
      "You leave with clarity. Not a prescription, not a script — a reflection you can trust.",
    ],
    includes: [
      "60 minutes of private conversation",
      "Any topic, any question",
      "Delivered by video or phone",
      "Dawn reaches out after purchase to schedule",
    ],
  },
];

export const SHORTS = [
  { id: "p-5MnBi7g-M", title: "This Question Changes Everything." },
  { id: "MJb_RhtazA4", title: "One Question" },
  { id: "YVPo2TgrYCc", title: "The Key to What's Repeating" },
  { id: "2S8Eomqd7Rg", title: "You're Not Broken" },
];

export const HOME_SEO = {
  title: "Life Clarity Chic | Pattern Recognition Sessions | SnapshotFame™",
  description: "Dawn Delisle — Life Clarity Chic. 40+ years of pattern recognition. Guided digital snapshots, Mirror Lotus deck & private clarity sessions. One question. One pattern. One new perspective.",
  keywords: "life clarity chic, pattern recognition, dawn delisle, snapshot fame, mirror lotus, intuitive reader, digital psychic reading, spiritual guidance, self-reflection experience",
};

export const ABOUT_SEO = {
  title: "About Dawn Delisle — Life Clarity Chic | SnapshotFame",
  description: "Meet Dawn Delisle. More than 40 years of recognizing human patterns through thousands of conversations. No coaching. No diagnosis. Just mirrors.",
  keywords: "dawn delisle, life clarity chic, six senses mirror, intuitive coach, pattern recognition expert, spiritual mentor, about dawn delisle",
};

export const HERO_PHOTO_URL = "/dawn-with-dog-hero.jpg";

// Focus Mode: true hides other services so visitors focus on Let's Talk Now. Set false to restore everything.
export const FOCUS_MODE = true;
export const FOCUS_SESSION_PATH = "/sessions/clarity-session";
